import advisoryRoutes from "meetings/advisory/routes";
import groupMeetingRoutes from "meetings/group-meeting/routes";
import myMeetingsRoutes from "meetings/shared/routes";
import studentMeetingRoutes from "meetings/student-meeting/routes";

export default [
  ...myMeetingsRoutes,
  ...advisoryRoutes,
  ...groupMeetingRoutes,
  ...studentMeetingRoutes,
];
